/* TROVI · tv-hero-slides
   Rotación de la banda hero: 6 s por defecto, pausa al pasar el mouse o enfocar,
   puntos accesibles (tablist), sin auto-rotación con prefers-reduced-motion ni con
   la pestaña oculta. Con una sola slide no hace nada.
   r86: escucha el cambio de prefers-reduced-motion durante la visita (para el
   temporizador al activarse; la navegación manual sigue) y retira todos los
   oyentes del documento al desconectarse (recargas de sección del editor). */
(function () {
  'use strict';
  if (window.customElements.get('tv-hero-slides')) return;

  class TvHeroSlides extends HTMLElement {
    connectedCallback() {
      this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-tv-slide]'));
      if (this.slides.length < 2) return;
      this.copies = Array.prototype.slice.call(this.querySelectorAll('[data-tv-slide-copy]'));
      this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-tv-dot]'));
      this.index = 0;
      this.timer = null;
      this.interval = parseInt(this.getAttribute('data-interval'), 10) || 6000;

      var self = this;
      this.mql = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
      this.reduced = !!(this.mql && this.mql.matches);
      this.onMotionChange = function (e) {
        self.reduced = !!e.matches;
        if (self.reduced) self.stop(); else self.start();
      };
      if (this.mql) {
        if (typeof this.mql.addEventListener === 'function') this.mql.addEventListener('change', this.onMotionChange);
        else if (typeof this.mql.addListener === 'function') this.mql.addListener(this.onMotionChange);
      }

      this.dots.forEach(function (dot, k) {
        dot.addEventListener('click', function () {
          self.go(k);
          self.restart();
        });
        dot.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') { self.go((self.index + 1) % self.slides.length); self.dots[self.index].focus(); }
          if (e.key === 'ArrowLeft') { self.go((self.index - 1 + self.slides.length) % self.slides.length); self.dots[self.index].focus(); }
        });
      });
      this.addEventListener('mouseenter', function () { self.stop(); });
      this.addEventListener('mouseleave', function () { self.start(); });
      this.addEventListener('focusin', function () { self.stop(); });
      this.addEventListener('focusout', function () { self.start(); });
      this.onVisibility = function () {
        if (document.hidden) self.stop(); else self.start();
      };
      document.addEventListener('visibilitychange', this.onVisibility);
      this.start();
    }

    disconnectedCallback() {
      this.stop();
      if (this.onVisibility) {
        document.removeEventListener('visibilitychange', this.onVisibility);
        this.onVisibility = null;
      }
      if (this.mql && this.onMotionChange) {
        if (typeof this.mql.removeEventListener === 'function') this.mql.removeEventListener('change', this.onMotionChange);
        else if (typeof this.mql.removeListener === 'function') this.mql.removeListener(this.onMotionChange);
        this.onMotionChange = null;
      }
    }

    go(k) {
      if (k === this.index) return;
      // A partir del primer cambio el CSS puede animar la entrada del texto;
      // la primera pintura (sin esta clase) es estática.
      this.classList.add('is-ready');
      var prev = this.index;
      this.index = k;
      this.slides[prev].classList.remove('is-active');
      this.slides[prev].setAttribute('aria-hidden', 'true');
      this.slides[k].classList.add('is-active');
      this.slides[k].removeAttribute('aria-hidden');
      var img = this.slides[k].querySelector('img');
      if (img && img.loading === 'lazy') img.loading = 'eager';
      if (this.copies[prev]) this.copies[prev].hidden = true;
      if (this.copies[k]) this.copies[k].hidden = false;
      if (this.dots[prev]) { this.dots[prev].setAttribute('aria-selected', 'false'); this.dots[prev].tabIndex = -1; }
      if (this.dots[k]) { this.dots[k].setAttribute('aria-selected', 'true'); this.dots[k].tabIndex = 0; }
    }

    start() {
      if (this.reduced || this.timer || document.hidden) return;
      var self = this;
      this.timer = window.setInterval(function () {
        self.go((self.index + 1) % self.slides.length);
      }, this.interval);
    }

    stop() {
      if (this.timer) { window.clearInterval(this.timer); this.timer = null; }
    }

    restart() { this.stop(); this.start(); }
  }

  window.customElements.define('tv-hero-slides', TvHeroSlides);
})();
